import { useDeleteMedComplexCertificateMutation } from '@/api'
import type { MedComplexCertificate } from '@/api/models/medcomplex'
import { useDrawer, useRole } from '@/hooks'
import { DrawerType } from '@/store/app'
import AddIcon from '@mui/icons-material/Add'
import { Box, Button, Checkbox, Grid, Stack, Tooltip } from '@mui/material'
import dayjs from 'dayjs'
import { useCallback, useContext, useState } from 'react'
import {
  Accordion,
  AccrodionControl,
  CertificateStatus,
  TableBox,
} from '../../components'
import { PenEditIcon } from '../../icons'
import { TrashIcon } from '../../icons/TrashIcon'
import { MedComplexContext } from '../../MedComplex'
import { CreateDocument } from './drawers'
import { PdfIcon } from './icons'
import { styles } from './styles'

export const VerificationInfo = () => {
  const { medcomplex, refetch } = useContext(MedComplexContext)
  const { showDrawer } = useDrawer()
  const [deleteCertificate] = useDeleteMedComplexCertificateMutation()
  const [selected, setSelected] = useState<number[]>([])

  const [chosenItem, setChosenItem] = useState<MedComplexCertificate | null>(
    null
  )

  const [certificateSignal, setCertificateSignal] = useState<number>()

  const checkboxHandle = useCallback(
    (id: number) => {
      const newSelected = selected.includes(id)
        ? selected.filter((item) => item !== id)
        : [...selected, id]
      setSelected(newSelected)
    },
    [selected, setSelected]
  )

  const deleteSelected = async () => {
    if (medcomplex.id && selected.length > 0) {
      await Promise.all(
        selected.map(async (certId) => {
          await deleteCertificate({ id: medcomplex.id, certId: certId })
        })
      ).then(() => {
        refetch()
      })
    }
  }

  const createSignal = (id: number) => {
    setCertificateSignal(id)
    setTimeout(() => {
      setCertificateSignal(-1)
    }, 2000)
  }

  // console.log(new Date(medcomplex.certificates[0].date_expiration))
  // console.log(new Date() < new Date(medcomplex.certificates[0].date_expiration))

  // const border = new Date(
  //   new Date(medcomplex.certificates[0].date_expiration).getTime() -
  //   29 * 24 * 60 * 60 * 1000
  // )
  // console.log('current = ', new Date())
  // console.log('end =', new Date(medcomplex.certificates[0].date_expiration))
  // console.log('border = ', border)
  // console.log(
  //   new Date() >=
  //   new Date(
  //     new Date(medcomplex.certificates[0].date_expiration).getTime() -
  //     29 * 24 * 60 * 60 * 1000
  //   ) && new Date() <= new Date(medcomplex.certificates[0].date_expiration)
  // )

  const { access } = useRole('MEDCOMPLEX', ['UPDATE'])

  return (
    <Stack gap={'8px'}>
      <Stack direction={'row'} justifyContent={'space-between'}>
        <Box></Box>
        <Stack direction={'row'} gap={'12px'}>
          {access && (
            <Button
              variant="outlined"
              sx={{
                color: '#8E8E8E',
                border: '2px solid #BDBDBD',
                '&:hover': {
                  border: '2px solid #BDBDBD',
                },
              }}
              onClick={deleteSelected}
            >
              <TrashIcon />
            </Button>
          )}
          {access && (
            <Button
              startIcon={<AddIcon />}
              variant="contained"
              onClick={() => {
                setChosenItem(null)
                showDrawer(
                  DrawerType.CREATE_MEDCOMPLEX__CREATE_VERIFICATION_DOCUMENT
                )
              }}
            >
              Добавить документ
            </Button>
          )}
        </Stack>
      </Stack>
      {medcomplex?.certificates?.length > 0 ? (
        medcomplex.certificates
          // ?.slice()
          // .reverse()
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          ?.map((item: any, index: number) => (
            <Accordion
              key={index.toString()}
              status={
                <CertificateStatus
                  status={item?.status}
                  date={dayjs(item?.date_expiration).format('DD.MM.YYYY')}
                />
              }
              color={certificateSignal === item.id ? 'success' : 'default'}
              title={
                <Stack direction={'row'} alignItems={'center'}>
                  {access && (
                    <Checkbox
                      color="primary"
                      sx={{ marginLeft: '-8px' }}
                      checked={selected.includes(item.id)}
                      onChange={() => checkboxHandle(item.id)}
                    />
                  )}
                  Сертификат поверки
                </Stack>
              }
              buttons={
                <Stack direction={'row'} alignItems={'center'}>
                  {access && (
                    <Tooltip arrow title="Редактировать" placement="top">
                      <Box>
                        <AccrodionControl
                          onClick={() => {
                            setChosenItem(item)
                            showDrawer(
                              DrawerType.CREATE_MEDCOMPLEX__CREATE_VERIFICATION_DOCUMENT
                            )
                          }}
                        >
                          <PenEditIcon />
                        </AccrodionControl>
                      </Box>
                    </Tooltip>
                  )}
                  {/* <Tooltip arrow title={'Удалить'} placement="top">
                  <Box>
                    <AccrodionControl color={'error'}>
                      <TrashIcon />
                    </AccrodionControl>
                  </Box>
                </Tooltip> */}
                </Stack>
              }
            >
              <Box p={1.5}>
                <Stack spacing={1.5}>
                  <Box>
                    <TableBox isHead label={'Информация'} />
                    <TableBox label={'Дата поверки'}>
                      {dayjs(item?.date_inspection).format('DD.MM.YYYY')}
                    </TableBox>
                    <TableBox label={'Номер'}>{item?.serial_number}</TableBox>
                  </Box>
                  {item.files.length > 0 && (
                    <Box>
                      <TableBox isHead label={'Фотокопии'} />
                      <Box p={1.5}>
                        <Grid container spacing={1.5}>
                          {/*eslint-disable-next-line @typescript-eslint/no-explicit-any*/}
                          {item.files?.map((item: any, index: number) => (
                            <Grid key={index.toString()} item sm={1}>
                              <Box sx={styles.pdfIcon}>
                                <a href={item.url} target="_blank">
                                  {/* <PhotoCopyCard src="/images/adding_vehicle.png" /> */}
                                  <PdfIcon />
                                </a>
                                <Box sx={styles.title}>
                                  {`${item.ext_file_id}.pdf`}
                                </Box>
                              </Box>
                            </Grid>
                          ))}
                        </Grid>
                      </Box>
                    </Box>
                  )}
                </Stack>
              </Box>
            </Accordion>
          ))
      ) : (
        <Box
          sx={{
            backgroundColor: '#EEEEEE',
            height: '100px',
            borderRadius: '4px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          Для добавления сертификата поверки необходимо нажать кнопку «Добавить
          документ»
        </Box>
      )}
      <CreateDocument
        createSignal={createSignal}
        certificate={chosenItem}
        setCertificate={setChosenItem}
      />
    </Stack>
  )
}
